import React from 'react';
import Summary from './pages/Summary';
import Orders from './pages/Orders';
import Renews from "./pages/Renew";
import Location from './pages/Location';
import Language from './pages/Language';
import Products from './pages/Products';
import Purchases from './pages/Purchases';
import Billing from './pages/Billing';
import AddOns from './pages/AddOns';
import Bill from './pages/Bill';
import Payment from './pages/Payment';
import Success from './pages/Success';
import SUBSCRIPTION_UPGRADE from './pages/Subscription_Upgrade';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import i18n from "./i18n";
import Reports from './pages/Report';
// import SideBarContainer from './pages/SideBarContainer';
import { Auth, Amplify } from 'aws-amplify';
import { getAllLanguage } from '../src/services/language-service';
import { getPoolInformation } from './services/tenant-identity-service';
import { deleteCookie, getTokenDetailsByDecoding, getIdTokenFromCookie, readCookieByKeyName } from './services/cookie-storage-service';
import { getLocation } from './services/branch-service';
import awsPoolConfiguration from "./aws-exports";

let gatsbyUrl = process.env.REACT_APP_GATSBY_APPLICATION_URL;

export default class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      user: null,
      tenantUserName: '',
      tenantResult: null,
      locationArr: [],
    }

    console.log('Configurator running environment',process.env.NODE_ENV);
    console.log('Configurator running REACT_APP_ENVIRONMENT',process.env.REACT_APP_ENVIRONMENT);
  }

  setAuthStatus = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  setUser = user => {
    this.setState({ user: user });
  }

  setTenantUserName = name => {
    this.setState({ tenantUserName: name });
  }

  setTenantUserGuid = name => {
    this.setState({ tenantUserGuid: name });
  }

  setTenantResult = result => {
    this.setState({ tenantResult: result });
  }

  navigateToLoginPage = () => {
    let currentLanguage = localStorage.getItem("languageCode");

    if (currentLanguage) {
      if (currentLanguage === 'en') {
        window.location.replace(`${gatsbyUrl}/login`);
      } else {
        window.location.replace(`${gatsbyUrl}/${currentLanguage}/login`);
      }
    } else {
      window.location.replace(`${gatsbyUrl}/login`);
    }

    Auth.signOut();
    this.setAuthStatus(false);
    this.setUser(null);
    localStorage.clear();
    deleteCookie();
  }

  componentDidMount = async () => {
    try {
      let tenantGuid = null;
      let langugeGuid = null;
      // const urlParams = new URLSearchParams(window.location.search);
      // const currentLanguage = urlParams.get('language');
      let currentLanguage = await readCookieByKeyName('currentLanguage');
      // var PERMITTED_DOMAIN = "http://localhost:8000";
      // /**
      //  * Receiving message from other domain
      //  */
      // window.addEventListener('message', function (event) {
      //   // alert('Hai reshma' + event.data)
      //   console.log(' event.data+++++++++++++', event.data)
      //   if (event.origin === PERMITTED_DOMAIN) {
      //     //var msg = JSON.parse(event.data);
      //     // var msgKey = Object.keys(msg)[0];
      //     if (event.data) {
      //       const payload = JSON.parse(event.data);
      //       console.log('payload++++++++++++', payload)
      //       localStorage.setItem(payload.key, JSON.stringify(payload.value));
      //     }
      //     // else {
      //     //   localStorage.removeItem("localstorage");
      //     // }
      //   }

      //   if (event.origin !== PERMITTED_DOMAIN) {
      //     return;
      //   }

      // });


      if (currentLanguage) {
        langugeGuid = await this.getLanguageGuid(currentLanguage);
        localStorage.setItem('languageCode', currentLanguage);
        localStorage.setItem('languageGuid', langugeGuid);
      }

      i18n.changeLanguage(localStorage.getItem('languageCode'));

      let token = getIdTokenFromCookie();

      if (token !== '' && token !== undefined && token !== null) {
        tenantGuid = getTokenDetailsByDecoding().tenantGuid;
        let result = await getPoolInformation(tenantGuid);

        // let refreshToken = await readCookieByKeyName('refreshToken');
        // console.log('###############', refreshToken);
        // await this.generateNewToken(result.clientId, refreshToken);

        awsPoolConfiguration.aws_project_region = result.region;
        awsPoolConfiguration.aws_cognito_identity_pool_id = result.identityPoolId;
        awsPoolConfiguration.aws_cognito_region = result.region;
        awsPoolConfiguration.aws_user_pools_id = result.userPoolId;
        awsPoolConfiguration.aws_user_pools_web_client_id = result.clientId;

        Amplify.configure(awsPoolConfiguration);

        //check user logged in or not.
        Auth.currentSession().then(async (session) => {
          this.setAuthStatus(true);
          let user = await Auth.currentAuthenticatedUser();
          let userAttributes = await Auth.currentUserInfo(user);
          let tenantUserName = userAttributes.attributes['custom:tenantUserName'];
          let tenantUserGuid = userAttributes.attributes['custom:tenantUserGuid'];


          this.setUser(user);
          this.setTenantUserName(tenantUserName);
          this.setTenantUserGuid(tenantUserGuid);
          this.setTenantResult(result);
          await this.getBranch();
          localStorage.setItem('isTenantPurchased', result.isPurchase);
          localStorage.setItem('locationCount', this.state.locationArr.length);
        }).catch((error) => {
          console.log('currentSession err ************', error);
          this.navigateToLoginPage();
        });

        this.setState({ isAuthenticating: false });

      }
      else {
        this.navigateToLoginPage();
      }

    } catch (error) {
      console.log('configurator error', error);
    }
  }

  // generateNewToken = async (appClientId, refreshToken) => {
  //   fetch("https://cognito-idp.ap-south-1.amazonaws.com/", {
  //     headers: {
  //       "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
  //       "Content-Type": "application/x-amz-json-1.1",
  //     },
  //     mode: 'cors',
  //     cache: 'no-cache',
  //     method: 'POST',
  //     body: JSON.stringify({
  //       ClientId: appClientId,
  //       AuthFlow: 'REFRESH_TOKEN_AUTH',
  //       AuthParameters: {
  //         REFRESH_TOKEN: refreshToken,
  //         //SECRET_HASH: "your_secret", // In case you have configured client secret
  //       }
  //     }),
  //   }).then(async (res) => {
  //     console.log('%%%%%%%%%%%%%%%%%', JSON.stringify(res))
  //     let a = await res.json();
  //     console.log('44444444', a)
  //     return res.json(); // this will give jwt id and access tokens
  //   }).catch((err) => {
  //     console.log('err++++++++++++', JSON.stringify(err))
  //   });
  // }

  getBranch = async () => {
    try {
      let response = await getLocation();

      if (response) {
        let locationResult = response.data.getBranch;
        this.setState({ locationArr: locationResult });
      }

    } catch (error) {
      console.log('getBranch error', error);
    }
  }

  getLanguageGuid = async (code) => {
    let languageArr = await getAllLanguage();
    let languageObj = languageArr.find((obj) => {
      return obj.Code.toUpperCase() === code.toUpperCase();
    });

    return languageObj.LanguageId.toUpperCase();
  }

  render() {
    const authProps = {
      isAuthenticated: this.state.isAuthenticated,
      user: this.state.user,
      tenantUserName: this.state.tenantUserName,
      tenantResult: this.state.tenantResult,
      tenantUserGuid: this.state.tenantUserGuid,
      setAuthStatus: this.setAuthStatus,
      setUser: this.setUser,
      locationCount: this.state.locationArr.length,
    }

    return (
      !this.state.isAuthenticating &&
      <fieldset>
        {/* <iframe style="display:none;" src="http://localhost:8000/getlocalstorage.html" id="ifr"></iframe> */}

        <Router>
          {/* ---- Here we can pass the default props like props.history,props.location as well as authProps function to summary cmponent as an argument using render function -----*/}
          <Switch>
            <Route exact strict path="/" render={(props) => <Summary {...props} auth={authProps} />} />
            <Route exact strict path="/Summary" render={(props) => <Summary {...props} auth={authProps} />} />
            <Route exact strict path="/Language" render={(props) => <Language {...props} auth={authProps} />} />
            <Route exact strict path="/Location" render={(props) => <Location {...props} auth={authProps} />} />
            <Route exact strict path="/Products" render={(props) => <Products {...props} auth={authProps} />} />
            <Route exact strict path="/Subscription_Upgrade" render={(props) => <SUBSCRIPTION_UPGRADE {...props} auth={authProps} />} />
            <Route exact strict path="/Purchases" render={(props) => <Purchases {...props} auth={authProps} />} />
            <Route exact strict path="/Billing" render={(props) => <Billing {...props} auth={authProps} />} />
            <Route exact strict path="/Payment" render={(props) => <Payment {...props} auth={authProps} />} />
            <Route exact strict path="/Success" render={(props) => <Success {...props} auth={authProps} />} />
            <Route exact strict path="/Bill" render={(props) => <Bill {...props} auth={authProps} />} />
            <Route exact strict path="/AddOns" render={(props) => <AddOns {...props} auth={authProps} />} />
            <Route exact strict path="/Renews" render={(props) => <Renews {...props} auth={authProps} />} />
            <Route exact strict path="/Orders" render={(props) => <Orders {...props} auth={authProps} />} />
            <Route exact strict path="/Reports" render={(props) => <Reports {...props} auth={authProps} />} />
            {/* <Route exact strict path="/SideBarContainer" render={(props) => <SideBarContainer {...props} auth={authProps} />} /> */}
          </Switch>
        </Router>
      </fieldset>
    )
  };
}
